import React from "react"
import { Row, Col, Container} from 'react-bootstrap';

export default function() {

    return (
        <div className="banner-company">  
            <Container> 
                <Row style={{marginLeft: "-16px"}}>
                    <Col xs={12} md={12} lg={12} className="banner-title">
                        <p className="title">Meet with Sogody</p>
                        <p className="subtitle">Your best-in-class martech company</p>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}



